import React from "react";
import { useTranslation } from "react-i18next";

import ForumTopicCard from "./ForumTopicCard";

export default function ForumTopicList({
    topics = [],
    loading = false,
    onDetail,
    onEdit,
    onDelete
}) {

    const { t } = useTranslation();
    if (loading) {
        return (
            <div className="text-center py-5">
                <div
                    className="spinner-border text-success"
                    role="status"
                >
                    <span className="visually-hidden">
                        {t("common.loading")}
                    </span>
                </div>

                <h5 className="mt-3 text-muted">
                    {t("forum.loadingTopics")}
                </h5>

            </div>
        );
    }

    // ==========================================================
    // Aucun sujet
    // ==========================================================

    if (!topics || topics.length === 0) {
        return (
            <div className="card shadow-sm border-0">
                <div className="card-body text-center py-5">
                    <i
                        className="
                            bi
                            bi-chat-square-text
                            display-1
                            text-success
                        "
                    ></i>

                    <h4 className="mt-4">
                        {t("forum.noTopics")}
                    </h4>

                    <p className="text-muted">
                        {t("forum.beFirstToReply")}
                    </p>

                </div>
            </div>
        );
    }

    // ==========================================================
    // Liste des sujets
    // ==========================================================
    return (
        <div className="row">
            {topics.map((topic) => (
                <div
                    key={topic.id}
                    className="col-12 mb-4"
                >
                    <ForumTopicCard
                        topic={topic}
                        onDetail={onDetail}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                </div>

            ))}
        </div>

    );

}